import { Component, WritableSignal, inject } from '@angular/core';
import { Card } from '@core/models/card';
import { ILoginResponse } from '@core/interfaces/ilogin-response';
import { ICourses } from '@core/interfaces/ilookup';
import { AuthService } from '@core/services/auth.service';
import { LookupService } from '@core/services/lookup.service';
import { IUserCourse } from '@views/features/courses/interfaces/iuser-course';
import { UserCourseService } from '@views/features/courses/services/user-courses.service';
import { take, tap } from 'rxjs';
import { CardService } from '@core/services/card.service';
import { IUserCourseHistoryByYear } from '@views/features/courses/interfaces/iuser-course-history-by-year';

@Component({
  selector: 'prism-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  private lookupService = inject(LookupService);
  private authService = inject(AuthService);
  private userCourseService = inject(UserCourseService);
  private cardService = inject(CardService);
  private courseContainer = 'courses';

  currentUser: WritableSignal<ILoginResponse | null> = this.authService.currentUserInfo;
  userCoursesByYear: IUserCourseHistoryByYear[] = [];
  userCourses: IUserCourse[] = [];
  courses: ICourses[] = [];
  sasToken: string = '';

  viewCourse = (card: Card) => this.cardService.viewCard(card.courseId ?? card.id!, '/course/', card.userCourseId);

  get courseList(): Card[] {
    if (this.courses.length === 0) return [];
    return this.cardService.mapCardDataToDataList(this.courseContainer, this.courses, this.sasToken);
  }
  get userCourseList(): Card[] {
    if (this.userCourses.length === 0) return [];
    return this.cardService.mapCardDataToDataList('user-course', this.userCourses, this.sasToken);
  }

  ngOnInit(): void {
    this.getSasToken();
  }

  getSasToken(): void {
    this.authService.fetchSasToken(this.courseContainer, (token) => {
      this.sasToken = token;
      this.getCourses();
      this.getCourseHistory();
    });
  }

  getCourses(): void {
    this.lookupService.getCourses().pipe(
      take(1),
      tap((res: ICourses[]) => {
        this.courses = res;
      })
    ).subscribe();
  }

  getCourseHistory(): void {
    this.userCourseService.getCourseHistory().pipe(
      take(1),
      tap((res: IUserCourseHistoryByYear[]) => {
        this.userCoursesByYear = res ?? [];

        const currentIndex = this.userCoursesByYear.findIndex(x => x.schoolYear?.isCurrent);

        this.userCoursesByYear.forEach(x => x.isActive = false);

        if (currentIndex >= 0) {
          this.userCoursesByYear[currentIndex].isActive = true;
        } else if (this.userCoursesByYear.length > 0) {
          this.userCoursesByYear[0].isActive = true;
        }
      })
    ).subscribe();
  }


  toggleYearPanel(index: number): void {
    const panel = this.userCoursesByYear[index];
    panel.isActive = !panel.isActive;
  }

  mapUserCoursesToCards(courses: IUserCourse[]): Card[] {
    if (!courses || courses.length === 0) return [];
    return this.cardService.mapCardDataToDataList('user-course', courses, this.sasToken);
  }

}
